













































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositOverdraftSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositOverdraftSettings';
import AccountDepositOverdraftSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/Overdraft/AccountDepositOverdraftSettingsEditDialog.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositOverdraftSettingsRead', components: { AccountDepositOverdraftSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountDepositOverdraftSettings;

    @Prop({required: true })
    showZeroInterestWarning: boolean;

    get visibility() {
        return DepositAccountSettingsModule.productFeatureVisibility;
    }

    async deleteDepositOverdraftAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositOverdraftSettings();
        }
    }

}
